// Regional configuration for Burkina Faso
export const REGIONAL_CONFIG = {
  // Phone number settings
  phone: {
    countryCode: '+226',
    format: 'XX XX XX XX',
    length: 8,
    example: '+226 70 12 34 56'
  },
  
  // Currency settings
  currency: {
    code: 'XOF',
    symbol: 'FCFA',
    locale: 'fr-BF',
    decimalPlaces: 0
  },
  
  // Date and time settings
  dateTime: {
    dateFormat: 'dd/MM/yyyy',
    timeFormat: 'HH:mm',
    dateTimeFormat: 'dd/MM/yyyy HH:mm',
    locale: 'fr-BF'
  },
  
  // Default location settings
  defaultLocation: {
    lat: 12.3714,  // Ouagadougou coordinates
    lng: -1.5197,
    zoom: 7
  },
  
  // Business hours (in 24h format)
  businessHours: {
    start: 8,   // 8:00 AM
    end: 18     // 6:00 PM
  },
  
  // Common validation messages
  validation: {
    phone: 'Please enter a valid phone number in the format: +226 XX XX XX XX',
    required: 'This field is required',
    email: 'Please enter a valid email address'
  }
} as const;

// Export types
export type RegionalConfig = typeof REGIONAL_CONFIG;
